import SocketIOClient from 'socket.io-client'
const socketEndpoint = process.env.REACT_APP_SOCKET_URL

const socket = SocketIOClient(socketEndpoint)

export default socket